import React from "react";
import { CalenderDay, Trophy, Clock } from "./icons";

function formatDate(dateString) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dateParts = dateString?.split("-");
  const year = dateParts[0].slice(2);
  const month = months[parseInt(dateParts[1]) - 1];
  const day = parseInt(dateParts[2]?.split(" ")[0]);
  const time = dateParts[2]?.split(" ")[2];
  const hour = parseInt(time?.split(":")[0]);
  const minute = parseInt(time?.split(":")[1]);
  const period = hour >= 12 ? "pm" : "am";
  const hour12 = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;

  return `${day} ${month} ${year}, ${hour12}:${minute < 10 ? "0" + minute : minute
    } ${period}`;
}

function ContestDates({ fields }) {
  return (
    <>
      {fields?.length > 0 && (
        <div>
          {/* Register Before & Result */}
          <div className=" flex justify-between p-2 border-b-1 border-b-gray-200">
            {fields?.slice(0, 2).map((item, index) => (
              <div className=" flex gap-2 items-start" key={item?.response}>
                <img
                  src={index === 0 ? CalenderDay : Trophy}
                  alt="icon"
                  className=" size-4 mt-1"
                />
                <div className="flex flex-col ">
                  <p className="text-sm text-[#707C97]">{item?.title}</p>
                  <h3 className="text-[#0D1C2E] text-sm md:text-base font-gilroy-medium">
                    {formatDate(item?.response)}
                  </h3>
                </div>
              </div>
            ))}
          </div>
          {/* Submission Start & Submission End */}
          <div className=" flex justify-between p-2 ">
            {fields?.slice(2, 4).map((item) => (
              <div className=" flex gap-2 items-start" key={item?.response}>
                <img src={Clock} alt="icon" className=" size-4 mt-1" />
                <div className="flex flex-col ">
                  <p className="text-sm text-[#707C97]">{item.title}</p>
                  <h3 className="text-[#0D1C2E] text-sm md:text-base font-gilroy-medium">
                    {formatDate(item?.response)}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default ContestDates;
